
<!-- TODO appendToBody -->

<template>

	<b-modal :id="id" size="xl" @show="reset" @hidden="reset" title="Множественное редактирование. Функциональные группа и подгруппа" @ok="ok" ok-title="Применить" cancel-title="Отменить" cancel-variant="outline-primary-secondary" no-close-on-backdrop>

		<form @submit.stop.prevent="submit">

			<b-form-group :state="value_state" label="Функциональные группа и подгруппа" label-for="value_input" invalid-feedback="Необходимо выбрать функциональные группу и подгруппу">
				
				<v-select :clearable="false" id="value_input" v-model="value" :reduce="obj => obj.functional_sub_group" :options="values" clearSearchOnSelect required/>

			</b-form-group>

		</form>

	</b-modal>

</template>

<script>

import { uuid } from "vue-uuid"
import api from "../../../../api"

export default
{
	props :
	{
		essence : String,
	},

	data()
	{
		return {
			
			id : uuid.v1(),

			value : null,
			value_state : null,
			values : [],

		}
	},

	methods :
	{
		check()
		{
			this.value_state = ( this.value != null )

			return this.value_state
		},

		reset()
		{
			var values = []

			this.value = null
			this.value_state = null

			api.call(this, "cadastral_attrs", "get_by", { field : "key", value : "attrs.functional_sub_group" },
				response =>
				{
					const subgroup_ref = response.data.reference

					Object.entries(subgroup_ref.original).forEach(
						elem =>
						{
							const code = elem[0]
							const label = elem[1]
							const group_code = parseInt(code.slice(0, 2))

							values.push(
								{
									label : code + " ( " + label + " )",
									functional_group : group_code.toString(),
									functional_sub_group : code
								})
						})

					this.values = api.sort_objects_array_by_key(values, "label")
				})
		},

		execute()
		{
			this.$bvModal.show(this.id)
		},

		ok(event)
		{
			event.preventDefault()
			this.submit()
		},

		submit()
		{
			if(! this.check())
				return

			const obj = this.values.find(item => item.functional_sub_group == this.value)

			const params = {
				
				functional_group : obj.functional_group,
				functional_sub_group : obj.functional_sub_group,
				query : this.$parent.get_query(),

			}

			api.call_long_operation(this, this.essence + ". Множественное редактирование. Функциональные группа и подгруппа", this.$parent.service, "set_functional_group_sub_group_in_current_version_many", params,
			response =>
			{
				this.$parent.refresh_objects()
				api.open_response_url(response)
			},
			{ success_msg : "Значения Функциональной группы / подгруппы - обновлены" }
			)
			
			this.$nextTick(() => { this.$bvModal.hide(this.id, "modal-prevent-closing") })
		}
	}
}

</script>

